export default {
    intro: '看释义，选出正确的单词吧！',
    th: {
        order: '编号',
        meaning: '题目',
        answer: '正确答案',
        wrong: '错误答案',
        wrongChoices: '错误选项',
        correctRate: '正确率',
    },
    manySelectedWrongAnswer: '被选最多的错误答案',
    teacher: {
        setting: {
            addQuestion: '添加题目',
            searchCount: '搜索结果 {count} 个',
            defaultBadge: '默认',
            otherCount: '其他 {count} 个',
            waitHeader: '待添加词汇 ({count})',
            clearAll: '全部清空',
            registerCount: '添加 {count} 个到活动',
            sameWordBadge: '同名词条',
            emptyMeaningBadge: '无释义',
            autoExtract: '自动提取',
            delete: '删除',
            close: '关闭',
        },
        modal: {
            clearConfirm: {
                title: '清空所有待添加的词汇？',
                message: '所有待添加的词汇将被删除。继续吗？',
            },
            closeConfirm: {
                title: '丢弃已输入的内容吗？',
                message: '关闭后待添加列表的词汇会全部消失。继续吗？',
            },
            questionDelete: {
                title: '删除此题目？',
                // {word}: 被删除题目的词条。提示将从活动中永久移除。
                message: "题目 '{word}' 将从活动中删除。继续吗？",
            },
            waitItemDelete: {
                title: '删除待添加词汇？',
                // {word}: 被删除的待添加词汇。仅从队列中移除，不影响活动。
                message: "将 '{word}' 从待添加列表中删除。继续吗？",
            },
            // {count}: 因词典重复而跳过的词汇数
            duplicateNotice: '已注册的 {count} 个词汇未被添加。',
            // {count}: 因无释义而跳过的词汇数
            skippedNotice: '{count} 个无释义的词汇未被添加。',
            // 混合(无释义+有释义)登录时确认弹窗
            mixedEmptyConfirm: {
                title: '要注册吗？',
                line1: '{empty} 个无释义的词汇将不会被添加。',
                line2: '仅注册剩余的 {valid} 个词汇？',
            },
            // 仅剩无释义词汇时的提示
            onlyEmptyNotice: {
                title: '无法注册',
                message: '没有可注册的词汇。只剩下无释义的词汇。',
            },
            registerFailed: '添加失败。',
        },
    },
};
